/* eslint-disable class-methods-use-this */

export default class CreateMember {
    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'checkbox-cpr-yes':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'checkbox aktiv',
                    'eventLabel': 'ja til samtykke',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'checkbox-cpr-no':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'checkbox aktiv',
                    'eventLabel': 'nej til samtykke',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'input-cpr':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'inputfelt aktivt',
                    'eventLabel': 'cpr-nummer',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'input-email':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'inputfelt aktivt',
                    'eventLabel': 'email',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'input-phone':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'inputfelt aktivt',
                    'eventLabel': 'telefon',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'select-organisation':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'dropdown aktiv',
                    'eventLabel': 'organisation',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'checkbox-union':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'checkbox aktiv',
                    'eventLabel': 'faglig organisation samtykke',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'modal-show':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'impression',
                    'eventLabel': 'pop-up',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'next':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'cpr samtykke',
                    'eventAction': 'fortsæt',
                    'eventLabel': 'pop-up',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
        }
        
        return trackingObject;
    }
}
